import Tracker, { SanitizeLevel } from "@openreplay/tracker";
import { sanitizeData } from "./sanitize";
import type { DoctorBaseAttributes, Doctor } from "@interfaces";
import {
  ENV,
  OPENREPLAY_DISABLE_SECURE_MODE,
  OPENREPLAY_INGEST_POINT,
  OPENREPLAY_PROJECT_KEY,
} from "../environment";

export const SHOULD_TRACK_SESSION: boolean =
  ENV !== "development" && !!OPENREPLAY_PROJECT_KEY && !!OPENREPLAY_INGEST_POINT;

export const tracker = SHOULD_TRACK_SESSION
  ? new Tracker({
      projectKey: OPENREPLAY_PROJECT_KEY,
      ingestPoint: OPENREPLAY_INGEST_POINT,
      obscureInputEmails: false,
      obscureInputNumbers: false,
      obscureInputDates: false,
      obscureTextEmails: false,
      obscureTextNumbers: false,
      respectDoNotTrack: false,
      capturePerformance: true,
      defaultInputMode: 0,
      domSanitizer: () => SanitizeLevel.Plain,
      captureIFrames: true,
      network: {
        capturePayload: true,
        sessionTokenHeader: "",
        failuresOnly: false,
        ignoreHeaders: [],
        captureInIframes: true,
        sanitizer: sanitizeData,
      },
      canvas: {
        disableCanvas: false,
      },
      crossdomain: {
        enabled: true,
      },
      __DISABLE_SECURE_MODE: OPENREPLAY_DISABLE_SECURE_MODE === "true", //add this to be able to send events in localhost/staging
    })
  : null;

export const identifyOpenReplaySession = (
  doctorData: DoctorBaseAttributes | Doctor,
): void => {
  if (!SHOULD_TRACK_SESSION || !tracker) return;

  tracker.setUserID(doctorData.rut);
  tracker.setMetadata("name", `${doctorData.name} ${doctorData.lastName}`);

  if ("email" in doctorData && doctorData.email) {
    tracker.setMetadata("email", doctorData.email);
  }

  if ("code" in doctorData && (doctorData as Doctor).code) {
    tracker.setMetadata("code", (doctorData as Doctor).code);
  }
};
